import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { doneAction } from "./action";
import { ACTION } from "./types";
export const template = async (height, date, amount, refNumber, bankName, bankAccountNumber) => {
    return {
        layout: {
            id: ROUTE.PAYMENT_IN_PROGRESS,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: "paymentNotApprovedDC", type: WIDGET.PAYMENT_NOT_APPROVED
                }
            ],
        },
        datastore: {
            paymentNotApprovedDC: {
                height: height,
                date: date,
                amount: amount,
                refNumber: refNumber,
                bankName: bankName,
                bankAccountNumber: bankAccountNumber,
                doneAction: {
                    type: ACTION.DONE_ACTION,
                    routeId: ROUTE.PAYMENT_IN_PROGRESS,
                    payload: {}
                }
            },
        },
    };
};
export const paymentInProgressMF = {
    onLoad: async ({ getHeight }, { amount, date, refNumber, bankName, bankAccountNumber }) => {
        return Promise.resolve(template(getHeight(), date, amount, refNumber, bankName, bankAccountNumber));
    },
    actions: {
        [ACTION.DONE_ACTION]: doneAction,
    }
};
